<div *ngIf="parseResult">
    <div class="grid grid-cols-2">
        <sl-label size="large" i18n>Now match the data columns with the columns from your file.</sl-label>
        <div class="text-right">
            <sl-button type="primary" (click)="approve()" [disabled]="hasInvalidFields()" i18n>Approve columns</sl-button>
        </div>
    </div>

    <sl-alert class="mb-4" [open]="hasInvalidFields()" type="danger">
        <strong i18n>Some columns contains invalid data.</strong><br>
        <ul>
            <ng-container *ngFor="let field of fields">
            <li *ngIf="!field.valid">{{field.displayName}}</li>
            </ng-container>

        </ul>
    </sl-alert>
    <sl-table scroll-behaviour="horizontal">
        <sl-column *ngFor="let field of fields">
            <div class="matcher__column">{{field.displayName}}<!--sl-tooltip [content]="field.description" class="matcher__info-tooltip"><sl-icon name="question-circle"></sl-icon></sl-tooltip-->&nbsp;->&nbsp;<sl-select hoist style="display:inline-block"
                    [(ngModel)]="field.matchField" (ngModelChange)="fireChange(field)" size="small">
                    <sl-menu-item [value]="undefined" i18n>Omitted</sl-menu-item>
                    <sl-menu-item *ngFor="let field of fieldsAbs" [value]="field">{{field}}</sl-menu-item>
                </sl-select>
            </div>

        </sl-column>
        <sl-row *ngFor="let line of currentPage; let i = index">
            <sl-cell *ngFor="let cell of fields">{{line[cell.matchField!]}} <sl-icon name="exclamation-triangle"
                    class="matcher__warning-icon" *ngIf="!isValid(cell, i)"></sl-icon>
            </sl-cell>
        </sl-row>
    </sl-table>
    <div class="mt-3 text-right">
        <sl-pagination [totalPages]="totalPages" (pageChange)="page = $any($event).detail">
        </sl-pagination>
    </div>
</div>